import { render, staticRenderFns } from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=template&id=66110cda&scoped=true"
import script from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteRiepilogoOperatoriEquipeListModalComponent.vue?vue&type=style&index=0&id=66110cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66110cda",
  null
  
)

export default component.exports